// extracted by mini-css-extract-plugin
export var planCard = "_u6-0";
export var planList = "_u6-1";